// Filter-as-you-type matcher shared by every list page. The query is split
// into tokens; a row matches when EVERY token appears in at least one of its
// fields — so "garage draft" finds draft estimates about garage doors.

export function textMatches(query: string, ...fields: Array<string | number | null | undefined>): boolean {
  const tokens = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const haystack = fields
    .filter((f) => f !== null && f !== undefined && f !== "")
    .map((f) => String(f).toLowerCase());
  return tokens.every((t) => haystack.some((h) => h.includes(t)));
}
